// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically
  return(
    <footer className="font-small blue">
      <div className="footer-copyright text-center py-2">
        © {currentYear} Powered By :
        <span className = "ms-4"><img className="ChoreoLogo" src="/wso2-developer-platform-black.png" alt="WSO2 Developer Platform"/></span>
        <span><img className="AsgardeoLogo" src="/wso2-identity-platform-black.png" alt="WSO2 Identity Platform"/></span>
      </div>
    </footer>
  );
}
